function html2Escape(sHtml) {
  if (!sHtml) {return ''};
  return sHtml.replace(/[<>&"]/g, function (c) {
    return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c];
  });
}

export default html2Escape